module.exports = __webpack_public_path__ + "img/canadian_pine_list.cb8c7bb5.jpg";